module.exports = __webpack_public_path__ + "static/img/09.5f0538b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/09.jpg
// module id = p4SJ
// module chunks = 0